export default __webpack_public_path__ + "static/media/snow.69467c5f.svg";